import Model from './Model';

export default class QuotePosition extends Model {
  resource() {
    return 'quote-positions';
  }
}
